module.exports = __webpack_public_path__ + "img/resource-ecosystem.1f499297.jpg";